module.exports = __webpack_public_path__ + "img/img11.31fdc2c5.png";